import { render, staticRenderFns } from "./Adviserheader.vue?vue&type=template&id=72f15f0d&scoped=true"
import script from "./Adviserheader.vue?vue&type=script&lang=js"
export * from "./Adviserheader.vue?vue&type=script&lang=js"
import style0 from "./Adviserheader.vue?vue&type=style&index=0&id=72f15f0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f15f0d",
  null
  
)

export default component.exports